// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    chain as CreateUserAccountsHandler,
    CreateAccountsParameter,
} from "@guestsupply/App/Handlers/RequestWebsiteAccess/CreateUserAccounts";
import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { AccountInfoModel } from "@guestsupply/XDL/types";
import { addToEndOfChain, ApiHandler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<CreateAccountsParameter & HasOnSuccess<any> & HasOnError<unknown>, AccountInfoModel>;

export const XngGaRequestAccessEvent: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (props.apiResult && state.xGoogleAnalytics.includeRequestAccessEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: GOOGLE_EVENTS.REQUEST_ACCESS,
            affiliation: props.parameter?.companyName,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

const _GaRequestAccessEvent = XngGaRequestAccessEvent as any;
addToEndOfChain(CreateUserAccountsHandler, _GaRequestAccessEvent);
